exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mobile-signin .mobile-options {\n  transition: transform 0.5s; }\n  .mobile-signin .mobile-options.enabled {\n    transform: translateX(-100%); }\n    .mobile-signin .mobile-options.enabled > .mobile-trigger {\n      display: none; }\n    .mobile-signin .mobile-options.enabled > .providers {\n      display: block; }\n  .mobile-signin .mobile-options > .providers {\n    position: relative;\n    top: 0;\n    left: 0;\n    right: 0;\n    transform: translateX(100%);\n    display: none; }\n", ""]);

// exports
